module.exports = __webpack_public_path__ + "static/media/amex_white.bdcc87bf.png";